<div class="list-title">
    <span class="title">&nbsp;</span>
</div>
<div class="row p-0 m-0 page-table expanded-list">
    <div class="list-group-collapse duo flex-wrap list-item-container">
        <ng-container *ngFor="let roleInstitution of roleInstitutions; let i=index;">
            <div class="duo {{i === 0 ? 'first' : ''}} item list-item bg-transparent no-shadow">
                <div class="d-flex justify-content-between col">
                    <det-popover (click)="openDetEdit(roleInstitution);$event.stopPropagation();"
                        [extraClasses]="hasDeterminant(roleInstitution) ? 'active' : ''"
                        [determinant]="roleInstitution.jsonDeterminants" [hasErrors]="hasError(roleInstitution.jsonDeterminants)"
                        [placement]="'left'" [determinantMapById]="determinantMapById"></det-popover>
                </div>
            </div>
        </ng-container>
    </div>
</div>